export default "/static/images/build_roof_4.png?a70588febc08bc4724561875e0781453";